import React from 'react'

          // <div className="footer-copyright text-center py-3">© 2024 Copyright: Asfan</div>
export default function Footer() {
  return (
    <div>
      <footer className="page-footer font-small pt-4 text-light">
        <div className="container-fluid text-center text-md-left">
        <p className="text-center">Designed & Developed File-Conversion-Utility </p> 
        </div>
      </footer>

    </div>
  )
}
